import React, { useEffect, useState } from "react"
import * as API from "services/api"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import ContentBar from "components/shared/lists/ContentBar"
import { errorToast } from "components/shared/toast"
import FacilityGroupCodesSelect from "./FacilityGroupCodesSelect"

const getFailureMessage = (facilityCustomNameInSentence) => (
  `Something went wrong fetching ${facilityCustomNameInSentence} group codes.`
)

const facilityGroupCodesDescription = (facilityCustomName, facilityCustomNameInSentence) => (
  `Add or remove ${facilityCustomNameInSentence} group codes from this ${facilityCustomNameInSentence}. `
  + `${facilityCustomName} group codes can be used in workflow conditions.`
)

const noFacilityGroupCodesDescription = (facilityCustomNameInSentence) => (
  `This organization does not currently have any ${facilityCustomNameInSentence} group codes. `
  + `Visit Admin Panel > General Settings to manage ${facilityCustomNameInSentence} group codes.`
)

const FacilityGroupCodes = () => {
  const [facilityGroupCodes, setFacilityGroupCodes] = useState([])

  const {
    name: facilityCustomName,
    nameInSentence: facilityCustomNameInSentence,
  } = useCustomName(FACILITY_KEY)

  useEffect(() => {
    async function getFacilityGroupCodes() {
      const response = await API.facilityGroupCodes()

      if (response.ok) {
        setFacilityGroupCodes(response.data)
      } else {
        errorToast(getFailureMessage(facilityCustomNameInSentence))
      }
    }
    getFacilityGroupCodes()
  }, [facilityCustomNameInSentence])

  return (
    <ContentBar
      title={`${facilityCustomName} group codes`}
      description={facilityGroupCodes.length > 0
        ? facilityGroupCodesDescription(facilityCustomName, facilityCustomNameInSentence)
        : noFacilityGroupCodesDescription(facilityCustomNameInSentence)}
    >
      {facilityGroupCodes.length > 0 && (
        <FacilityGroupCodesSelect
          facilityGroupCodes={facilityGroupCodes}
        />
      )}
    </ContentBar>
  )
}

export default FacilityGroupCodes
